<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>统计分析</h4>
    </div>
    <el-tabs v-model="activeName" style="margin-left:10px;" type="card" @tab-click="handleClick">
    <el-tab-pane label="外发" name="first">
      <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="计划时间:" prop="collectPlanTime">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="searchFrom.collectPlanTime"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
             </el-form-item>
          <el-button type="primary" style="margin-left:40px;" size="mini" @click="waiFaClick" btnCode='00DP004B001' v-if="btnFlg[0]">查询</el-button>
        </div>
      </el-form>
    </div>
    <div id="myChart"></div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableList"
        ref="table"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column property="fleetName" label="车队"  align="center" ></el-table-column>
        <el-table-column prop="planWeight" label="计划量" align="center"></el-table-column>
        <el-table-column prop="totalAllowOut"    label="发货量" align="center"></el-table-column>
        <el-table-column prop=""  label="完成率（%）" align="center">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.totalAllowOut !== 0 && scope.row.planWeight !== 0">{{((scope.row.totalAllowOut / scope.row.planWeight)*100).toFixed(2)}}</span>
            <span v-else>0.00</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="surplusWeight"    label="未完成计划量" align="center"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <!-- <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div> -->
    </el-tab-pane>
    <el-tab-pane label="集港" name="second">
       <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="jiGangFrom" ref="jiGangFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="计划时间:" prop="collectPlanTime">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="jiGangFrom.collectPlanTime"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
             </el-form-item>
          <el-button type="primary" style="margin-left:40px;" size="mini" btnCode='00DP004B002' @click="jiGangSearch" v-if="btnFlg[1]">查询</el-button>
        </div>
      </el-form>
    </div>
    <div ref="myChart" :style="{width: '100%', height: '300px'}"></div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableData"
        ref="tableData"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column property="fleetName" label="车队"  align="center" ></el-table-column>
        <el-table-column prop="allCarNum"    label="标载（车）" align="center" ></el-table-column>
        <el-table-column prop="smallCarWeight"    label="标载（吨）"  width="140" align="center"></el-table-column>
        <el-table-column prop="bigCarNum" label="大载（车）" align="center"></el-table-column>
        <el-table-column prop="bigCarWeight"    label="大载（吨）" align="center"></el-table-column>
        <el-table-column prop="vehicleRunNum"  label="每车平均趟数" align="center"></el-table-column>
        <el-table-column prop="allCarNum"    label="合计（车）" align="center"></el-table-column>
        <el-table-column prop="allCarWeight" label="合计吨"  align="center" width="170"></el-table-column>
        <el-table-column prop="vehicleIdNum" label="运行车辆"  align="center" width="170"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <!--<div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="jiGangFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="jiGangFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>-->
    </el-tab-pane>
  </el-tabs>
  </div>
</template>
<script>
// 引入基本模板
import {
  tongJiFenXiWaiFa, // 外发
  tongJiFenXiJiGang // 集港
} from '@/api/zhb'
import { getBtn } from '@/utils/getButton'
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP004B001', '00DP004B002'],
      activeName: 'first',
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        // pageNo: 1,
        // pageSize: 10
        collectPlanTime: ''
      },
      jiGangFrom: {
        // pageNo: 1,
        // pageSize: 10
        collectPlanTime: ''
      },
      tableList: [],
      tableData: [],
      waiFaTuBiaoX: [], // 外发图标X轴数据
      waiFaYJiHuaLiang: [], // 外发y轴数据
      waiFaYFaYunLiang: [], // 外发y轴发运量
      waiFaYShengYuLiang: [], // 外发y轴剩余量
      // 集港
      JGTuBiaoX: [], // 集港图标X轴数据
      JGYHeJiChe: [], // 集港y轴数据
      JGYHeJiDun: [], // 集港y轴发运量
      JGYShengYuLiang: [], // 集港y轴剩余量
      planWeight: '',
      maxHeJiChe: '',
      maxHeJiDun: ''
    }
  },
  mounted () {
    // this.drawLine()
    this.showEcharts()
  },
  created () {
    this.getWaiFaData(this.searchFrom)
    this.getToDay()
    this.getJiGangData(this.jiGangFrom)
    this.btnFlg = getBtn(this.btnIdArr, '/statistics')
  },
  methods: {
    drawLine () {
      let option = {
        color: ['#5ba4f7', '#ed7d31', '#db7093'], // 分别对应两个柱状图的颜色
        textStyle: {
          color: '#828282'
        },
        title: {
          text: '车队完成情况',
          // subtext: '车队完成情况',
          left: 'center'
        },
        legend: {
          icon: 'square', // 在此处改变右上方图例的形状
          data: ['计划量', '发运量', '剩余量'], // 在此处设置图例的文本展示内容
          itemGap: 30,
          // 以下是定义图例展示的位置
          right: 0,
          top: 0,
          padding: 0
        },
        grid: {
          // 此处定义图表内容到周边的距离
          left: '3%',
          right: '0',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        // 这里定义x轴的数据展示
        xAxis: [
          {
            type: 'category',
            // data: ['天马', '兴创', '强誉', '天龙', '天虎', '吉祥', '地龙', '地虎'],
            data: this.waiFaTuBiaoX,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#e0e0e0'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: this.planWeight,
            interval: 100,
            axisTick: { show: false },
            axisLine: {
              lineStyle: {
                color: '#e0e0e0'
              }
            }
          },
          // 这里是利用双轴线展示成给图表添加右边框的效果
          {
            type: 'value',
            min: 0,
            max: this.planWeight,
            interval: 100,
            axisTick: { show: false },
            axisLine: {
              lineStyle: {
                color: '#e0e0e0'
              }
            },
            axisLabel: {
              textStyle: {
                // 在这里设置右边Y轴文字颜色
                color: 'transparent'
              }
            }
          }
        ],
        series: [
          {
            name: '计划量',
            type: 'bar',
            barWidth: '23px',
            // data: [220, 195, 150, 105, 135, 160, 115, 80]
            data: this.waiFaYJiHuaLiang
          },
          {
            name: '发运量',
            type: 'bar',
            barWidth: '23px',
            // data: [180, 165, 170, 130, 160, 80, 55, 95]
            data: this.waiFaYFaYunLiang
          },
          {
            name: '剩余量',
            type: 'bar',
            barWidth: '23px',
            // data: [400, 500, 600, 100, 200, 80, 700, 1000]
            data: this.waiFaYShengYuLiang
          }
        ]
      }
      // console.log('1')
      // 选择容器并初始化
      let myChart = this.$echarts.init(document.querySelector('#myChart'))
      // 设置容器的内容并进行图表绘制
      myChart.setOption(option)
      this.$nextTick(() => {
        myChart.resize()
      })
      setTimeout(function () {
        // 这里是让图表根据视图大小进行自适应
        window.onresize = function () {
          myChart.resize()
        }
      }, 200)
    },
    //
    showEcharts () {
      // 基于准备好的dom，初始化echarts实例
      let chartView = this.$echarts.init(this.$refs.myChart)
      // 绘制图表
      chartView.setOption({
        textStyle: {
          color: '#828282'
        },
        title: {
          text: '完成情况',
          // subtext: '车队完成情况',
          left: 'center'
        },
        legend: {
          selectedMode: true, // 可点击
          data: ['合计车', '合计吨'],
          itemGap: 30,
          // 以下是定义图例展示的位置
          right: 0,
          top: 0,
          padding: 0
          // bottom: 0
        },
        grid: {
          left: 100
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        toolbox: {
          // feature: {
          //   dataView: { show: true, readOnly: false },
          //   magicType: { show: true, type: ['line', 'bar'] },
          //   restore: { show: true },
          //   saveAsImage: { show: true }
          // }
        },
        // 集港
        xAxis: [
          {
            type: 'category',
            data: this.JGTuBiaoX,
            splitLine: {// 不显示分割线
              show: false
            }
          }

        ],
        yAxis: [
          {
            type: 'value',
            name: '合计车',
            min: 0,
            max: this.maxHeJiChe,
            interval: 50,
            axisTick: { show: false },
            axisLabel: {
              formatter: '{value} 辆'
            },
            axisLine: {
              lineStyle: {
                color: '#e0e0e0'
              }
            },
            splitLine: {// 显示分割线
              show: true
            }
          },
          {
            type: 'value',
            name: '合计吨',
            splitLine: {
              show: true
            },
            min: 0,
            max: this.maxHeJiDun,
            interval: 1000,
            axisTick: { show: false },
            axisLine: {
              lineStyle: {
                color: '#e0e0e0'
              }
            },
            axisLabel: {
              formatter: '{value} 吨'
              // textStyle: {
              //   // 在这里设置右边Y轴文字颜色
              //   color: 'transparent'
              // }
            }
          }
        ],
        series: [
          {
            name: '合计车',
            type: 'bar',
            data: this.JGYHeJiChe,
            itemStyle: {
          	  color: 'rgba(132, 136, 211, 1)'
          	}
          },
          {
            name: '合计吨',
            type: 'line',
            yAxisIndex: 1, // 索引从0开始
            data: this.JGYHeJiDun,
            // data: [5, 10, 15, 1000, 10000, 20000],
            itemStyle: {
              color: 'rgba(91, 245, 204, 1)'
            }
          }
        ]
      })
      this.$nextTick(() => {
        chartView.resize()
      })
      setTimeout(function () {
        // 这里是让图表根据视图大小进行自适应
        window.onresize = function () {
          chartView.resize()
        }
      }, 200)
      // 建议加上以下这一行代码，不加，当浏览器窗口缩小时，echarts显示不全。
      // window.addEventListener('resize', function () {
      //     chartView.resize()
      // })
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      const dateStartStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      const dateEndStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      // console.log(dateEndStr)
      // console.log((new Date()).getTime(),'22222')  //当前时间戳
      const nowDate = (new Date()).getTime()
      // console.log(new Date(dateStartStr).getTime(),'333')   // 早八点时间戳
      const morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) {
        this.searchFrom.collectPlanTime = this.timeStamp(new Date())
        this.jiGangFrom.collectPlanTime = this.timeStamp(new Date())
      } else {
        // 昨天的时间
        var day1 = new Date()
        day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
        var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
        // console.log(s1,'00000000')
        this.searchFrom.collectPlanTime = s1
        this.jiGangFrom.collectPlanTime = s1
      }
    },
    // 外发查询
    getWaiFaData () {
      tongJiFenXiWaiFa(this.searchFrom).then(res => {
        this.tableList = res.data2
        this.planWeight = this.tableList[this.tableList.length - 1].planWeight
        let data1 = res.data1
        this.waiFaTuBiaoX = []
        this.waiFaYJiHuaLiang = []
        this.waiFaYFaYunLiang = []
        this.waiFaYShengYuLiang = []
        data1.forEach((item, index) => {
          this.waiFaTuBiaoX.push(item.fleetName)
          this.waiFaYJiHuaLiang.push(item.planWeight)
          this.waiFaYFaYunLiang.push(item.totalAllowOut)
          this.waiFaYShengYuLiang.push(item.surplusWeight)
        })
        // console.log(this.waiFaYJiHuaLiang, '1111')
        this.drawLine()
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击外发查询按钮
    waiFaClick () {
      this.getWaiFaData(this.searchFrom)
    },
    // 集港查询数据
    getJiGangData () {
      tongJiFenXiJiGang(this.jiGangFrom).then(res => {
        this.tableData = res.data2
        this.maxHeJiChe = this.tableData[this.tableData.length - 1].allCarNum
        this.maxHeJiDun = this.tableData[this.tableData.length - 1].allCarWeight
        let data1JiGang = res.data1
        this.JGTuBiaoX = [] // 集港图标X轴数据
        this.JGYHeJiChe = [] // 集港y轴数据
        this.JGYHeJiDun = [] // 集港y轴发运量
        this.JGYShengYuLiang = [] // 集港y轴剩余量
        // allCarNum   合计车
        data1JiGang.forEach((item, index) => {
          this.JGTuBiaoX.push(item.fleetName)
          this.JGYHeJiChe.push(item.allCarNum)
          this.JGYHeJiDun.push(item.allCarWeight)
          // this.waiFaYShengYuLiang.push(item.surplusWeight)
        })
        // console.log(this.JGTuBiaoX, '22222')
        // console.log(this.JGYHeJiChe, '3333')
        this.showEcharts()
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 集港查询
    jiGangSearch () {
      this.getJiGangData(this.jiGangFrom)
    },
    handleClick (tab, event) {
      // console.log(tab, event)
      let chartView = this.$echarts.init(this.$refs.myChart)
      this.$nextTick(() => {
        chartView.resize()
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      // this.getSearchData()
    }
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#999;
  color: #fff;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

//  /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//    width: 150px;
// }
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width:  150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
#myChart{
  width: 100%;
  height: 300px;
}
</style>
